import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-school-reset-status>
  <paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opts.opname} edit={opts.edit} selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol}
    submitfunc={submitHandler}>
  
    <yield to="fields">
      <div class="row">
        <div class="col-md-12">
          <p>Der MDM-Status für die ausgewählte Schule wird zurückgesetzt.</p>
        </div>
      </div>
      <div class="row">
          <div class="col-md-12">
          <div class="mt-2 mr-1 p-2 border border-info">
              <span><paedml-icon icon="fas-info-circle" simple="info" />
                  <strong class="text-info pl-1 pt-2">Die Zurücksetzung des MDM-Status kann einige Minuten dauern.</strong>
              </span>
              </div>
          <div class="p-2"></div>
          </div>
      </div>
    </yield>
  </paedml-modal>
    
    <script>
      import { handleSubmitCreateOrEdit } from '../../util/api-util'
      
      this.opname = this.opts.opname
      this.data = {}
      this.edit = true
      this.api = this.opts.api
      this.patient = opts.patient

      this.data = {
        
      }

       this.on('dataRequested', (selectedRows) => {
        console.log(selectedRows)
      })

      this.submitHandler = formData => {
      console.log(this)
      return this.api.resetStatus(formData.ids[0]).then(rsp => {
        const [data, status] = rsp
        if (status.error) return Promise.reject('Kommunikationsfehler mit dem Server')

        if(status.success){
          this.parent.trigger('reloadTable')
          return 'Der Job zur Zurücksetzung des MDM Status wurde erfolgreich gestartet.'
        }
      })
    }
    </script>
</paedml-modal-school-reset-status>
